import { CONSENT } from 'Router/routes';
import { FakePageData } from '@4finance/cwt-test-helper';

const consentScenarios: FakePageData = {
  url: CONSENT,
  items: {
    'Accept consents': [
      ['[data-test="agreement-checkbox-legal-content"]', 'button'],
      ['[data-test="legal-modal-scrollable-content"]', 'scroll-to-bottom'],
      ['[data-test="modal-button"]', 'button'],
      ['[data-test="agreement-checkbox-agreement-content"]', 'button'],
      ['[data-test="agreement-modal-scrollable-content"]', 'scroll-to-bottom'],
      ['[data-test="modal-button"]', 'button'],
      ['[data-test="button"]', 'submit-button'],
    ],
  },
};

export { consentScenarios };
